import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { PlayerService } from './services/player.service';
import { AppService } from './services/app.service';
import { AuthService } from './services/auth.service';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';
import { MobileAccessibility } from '@ionic-native/mobile-accessibility/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SchedulerAccessService } from './services/scheduler-access.service';
import { SchedulerNavRevealService } from './services/scheduler-nav-reveal.service';
var AppComponent = /** @class */ (function () {
    function AppComponent(platform, splashScreen, statusBar, playerService, appService, authService, backgroundMode, mobileAccessibility, router, schedulerAccess, schedulerNavReveal, screenOrientation, document) {
        var _this = this;
        this.platform = platform;
        this.splashScreen = splashScreen;
        this.statusBar = statusBar;
        this.playerService = playerService;
        this.appService = appService;
        this.authService = authService;
        this.backgroundMode = backgroundMode;
        this.mobileAccessibility = mobileAccessibility;
        this.router = router;
        this.schedulerAccess = schedulerAccess;
        this.schedulerNavReveal = schedulerNavReveal;
        this.screenOrientation = screenOrientation;
        this.nyActive = false;
        this.isEmbeddedSchedulerRoute = false;
        /** On /scheduler, mobile landscape: hide header + tab bar for more grid space. */
        this.schedulerImmersiveChrome = false;
        /** On /scheduler, mobile portrait: suggest rotating phone for better weekly grid. */
        this.showSchedulerRotateHint = false;
        /** Immersive scheduler hides the tab bar; the page can ask for it back (title tap / scrolled to bottom). */
        this.schedulerNavRevealed = false;
        this.rotateHintButtons = [{ text: 'Понятно', role: 'cancel' }];
        this.schedulerRotateHintDismissedKey = 'schedulerRotateHintDismissed';
        /** Whether the hidden Scheduler entry is unlocked on this device (secret 7-tap on the logo). */
        this.schedulerUnlocked = false;
        this.initializeApp();
        this.trackEmbeddedRoute();
        this.updateSchedulerImmersiveChrome();
        this.updateSchedulerRotateHint();
        this.schedulerUnlocked = this.schedulerAccess.isUnlocked();
        this.schedulerNavReveal.revealed$.subscribe(function (revealed) {
            _this.schedulerNavRevealed = revealed;
        });
    }
    /**
     * Secret access to the new Scheduler: tap/click the logo 7 times within 4 seconds to reveal
     * the Scheduler tab on this device. Lets us QA in PROD under the client's account without
     * regular customers seeing it. Works the same with mouse (desktop) and touch (mobile).
     */
    AppComponent.prototype.onLogoTap = function () {
        if (this.schedulerAccess.registerLogoTap()) {
            this.schedulerUnlocked = true;
            // Open the scheduler right away: unmistakable confirmation and immediate access,
            // independent of whether the (dynamically added) tab button has re-rendered yet.
            this.router.navigateByUrl('/scheduler');
        }
        else {
            // Preserve the logo's normal "home" behavior for ordinary taps.
            this.router.navigateByUrl('/tab1');
        }
    };
    Object.defineProperty(AppComponent.prototype, "loading", {
        get: function () { return this.appService.loading; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "notification", {
        get: function () { return this.appService.notification; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "notificationClass", {
        get: function () { return this.appService.notificationClass; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "authenticated", {
        get: function () { return this.authService.authenticated; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "currentUser", {
        get: function () { return this.authService.currentUser; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "countOfBoldPlaylists", {
        get: function () { return this.playerService.state.playlists.filter(function (x) { return x.bold; }).length; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "showAppChrome", {
        get: function () { return !this.isEmbeddedSchedulerRoute; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppComponent.prototype, "isCordova", {
        get: function () { return this.platform.is('cordova'); },
        enumerable: true,
        configurable: true
    });
    AppComponent.prototype.initializeApp = function () {
        var _this = this;
        this.platform.ready().then(function () {
            try {
                var isCordova = _this.platform.is('cordova');
                if (isCordova) {
                    _this.statusBar.styleDefault();
                    _this.splashScreen.hide();
                    // Keep the whole app portrait by default (iOS allows landscape at the OS level so
                    // the scheduler can rotate; Android is portrait via the manifest). The scheduler
                    // screen unlocks orientation on entry and re-locks portrait on leave.
                    try {
                        _this.screenOrientation.lock(_this.screenOrientation.ORIENTATIONS.PORTRAIT);
                    }
                    catch (e) {
                        // ignore: orientation locking is best-effort
                    }
                    // Enable background mode only on real device/simulator with Cordova.
                    _this.backgroundMode.enable();
                    _this.backgroundMode.setDefaults({
                        title: 'YCD App',
                        text: 'Running in background',
                        silent: true
                    });
                }
                var platformWidth = _this.platform.width();
                if (isCordova && platformWidth <= 400) {
                    _this.mobileAccessibility.usePreferredTextZoom(false);
                    _this.mobileAccessibility.setTextZoom(100);
                }
                _this.platform.pause.subscribe(function () {
                    console.log('App paused - going to background');
                    try {
                        _this.playerService.platformPauseSubject.next(true);
                    }
                    catch (error) {
                        console.error('Error during pause:', error);
                    }
                });
                _this.platform.resume.subscribe(function () {
                    console.log('App resumed - coming to foreground');
                    try {
                        _this.playerService.platformPauseSubject.next(false);
                    }
                    catch (error) {
                        console.error('Error during resume:', error);
                    }
                });
            }
            catch (error) {
                console.error('Error during app initialization:', error);
            }
        }).catch(function (error) {
            console.error('Platform ready error:', error);
        });
    };
    AppComponent.prototype.trackEmbeddedRoute = function () {
        var _this = this;
        var updateFlag = function (url) {
            var cleanUrl = ((url || '').split('?')[0] || '').replace(/\/+$/, '');
            _this.isEmbeddedSchedulerRoute = cleanUrl === '/scheduler/embedded';
        };
        updateFlag(this.router.url);
        this.updateSchedulerImmersiveChrome();
        this.updateSchedulerRotateHint();
        this.router.events
            .pipe(filter(function (event) { return event instanceof NavigationEnd; }))
            .subscribe(function (event) {
            var navEvent = event;
            updateFlag(navEvent.urlAfterRedirects || navEvent.url || '');
            _this.updateSchedulerImmersiveChrome();
            _this.updateSchedulerRotateHint();
        });
    };
    AppComponent.prototype.updateSchedulerImmersiveChrome = function () {
        try {
            if (typeof window === 'undefined') {
                this.schedulerImmersiveChrome = false;
                return;
            }
            var cleanUrl = ((this.router.url || '').split('?')[0] || '').replace(/\/+$/, '');
            var isSchedulerRoute = cleanUrl === '/scheduler' || cleanUrl.startsWith('/scheduler/');
            var w = window.innerWidth || 0;
            // Width-only (w<=767) misses real phone landscape (width can be 844). Use the platform too.
            var isMobilePlatform = !!this.platform &&
                (this.platform.is('ios') ||
                    this.platform.is('android') ||
                    this.platform.is('mobile') ||
                    this.platform.is('mobileweb') ||
                    this.platform.is('hybrid'));
            var mobile = isMobilePlatform || w <= 767;
            var landscape = typeof window.matchMedia === 'function'
                ? window.matchMedia('(orientation: landscape)').matches
                : window.innerHeight < window.innerWidth;
            this.schedulerImmersiveChrome = isSchedulerRoute && mobile && landscape;
        }
        catch (_a) {
            this.schedulerImmersiveChrome = false;
        }
    };
    AppComponent.prototype.updateSchedulerRotateHint = function () {
        try {
            if (typeof window === 'undefined') {
                this.showSchedulerRotateHint = false;
                return;
            }
            if (this.isEmbeddedSchedulerRoute) {
                this.showSchedulerRotateHint = false;
                return;
            }
            var dismissed = window.sessionStorage.getItem(this.schedulerRotateHintDismissedKey) === '1';
            if (dismissed) {
                this.showSchedulerRotateHint = false;
                return;
            }
            var cleanUrl = ((this.router.url || '').split('?')[0] || '').replace(/\/+$/, '');
            var isSchedulerRoute = cleanUrl === '/scheduler' || cleanUrl.startsWith('/scheduler/');
            var w = window.innerWidth || 0;
            var mobile = w <= 767;
            var portrait = typeof window.matchMedia === 'function'
                ? window.matchMedia('(orientation: portrait)').matches
                : window.innerHeight >= window.innerWidth;
            this.showSchedulerRotateHint = isSchedulerRoute && mobile && portrait;
        }
        catch (_a) {
            this.showSchedulerRotateHint = false;
        }
    };
    AppComponent.prototype.onSchedulerChromeLayout = function () {
        this.updateSchedulerImmersiveChrome();
        this.updateSchedulerRotateHint();
    };
    AppComponent.prototype.onRotateHintDismiss = function () {
        try {
            window.sessionStorage.setItem(this.schedulerRotateHintDismissedKey, '1');
        }
        catch (_a) {
            // ignore
        }
        finally {
            this.showSchedulerRotateHint = false;
        }
    };
    AppComponent.prototype.ny1 = function (event) {
        event.stopPropagation();
        this.playerService.ny1();
        this.nyActive = false;
    };
    AppComponent.prototype.ny2 = function (event) {
        event.stopPropagation();
        if (confirm("Are you sure?")) {
            this.playerService.ny2();
            this.nyActive = false;
        }
    };
    AppComponent.prototype.onMainWindowClick = function (event) {
        this.nyActive = false;
    };
    /**
     * Opens the account/cabinet page. Uses a programmatic navigation instead of a passive routerLink:
     * on the immersive scheduler screen the routerLink on the header item did not navigate, so we
     * reset the scheduler nav-reveal state and navigate explicitly.
     */
    AppComponent.prototype.goToCabinet = function () {
        try {
            this.schedulerNavReveal.reset();
        }
        catch (_a) {
            // ignore
        }
        this.router.navigateByUrl('/auth/cabinet');
    };
    AppComponent.prototype.onNyPanelClick = function (event) {
        event.stopPropagation();
    };
    AppComponent.prototype.toggleNyPanel = function (event) {
        event.stopPropagation();
        this.nyActive = !this.nyActive;
    };
    AppComponent.prototype.playingNowClick = function (event) {
        if (document.URL.includes("tab1")) {
            var re = document.getElementsByClassName('playlist-open')[0];
            if (re !== null) {
                re.click();
            }
        }
    };
    AppComponent.prototype.playlistsClick = function (event) {
        var re = document.getElementById('playlistsongs-close');
        if (re != null) {
            re.click();
        }
    };
    return AppComponent;
}());
export { AppComponent };
